<template>
    <div class="panel panel-info">
        <!-- Default panel contents -->
        <div class="panel-heading">
            <i class="fa fa-info-circle" aria-hidden="true"></i> STATUS DA CAIXA PACPON
        </div>

        <div class="panel-body" v-if="status">
            <div class="form-group">

                <div class="row">

                    <div class="col-sm-3" style="margin-top: 3px">
                        <button class="btn btn-block btn-success" :disabled="buscando" @click="buscar()">
                            <span class="fa fa-sync-alt"></span> ATUALIZAR
                        </button>
                    </div>
                    <div class="col-sm-5">
                        <blockquote class="blockquote danger" v-if="buscando">
                            <span class="fa fa-sync-alt"></span> Atualizando
                        </blockquote>
                    </div>
                    <div class="col-sm-4">
                        <blockquote class="blockquote-reverse">
                            CAIXA ONLINE: <b>
                            <span v-if="status.online" class="text-success">SIM</span>
                            <span v-else class="text-danger">NÃO</span>
                        </b>
                        </blockquote>
                    </div>

                </div>

                <br/>
                <div class="row">
                    <div class="col-sm-3">
                        <label for="temperature" class="control-label">TEMPERATURA</label>
                        <input id="temperature" disabled type="text" :value="status.onu.temperature.value + ' ' + status.onu.temperature.unit" class="form-control" >
                    </div>

                    <div class="col-sm-3">
                        <label for="tx_power" class="control-label">TX POWER</label>
                        <input id="tx_power" disabled type="text" :value="status.onu.tx_power.value + ' ' + status.onu.tx_power.unit" class="form-control" >
                    </div>

                    <div class="col-sm-3">
                        <label for="rx_power" class="control-label">RX POWER</label>
                        <input id="rx_power" disabled type="text" :value="status.onu.rx_power.value + ' ' + status.onu.rx_power.unit" class="form-control" >
                    </div>

                    <div class="col-sm-3">
                        <label for="voltage" class="control-label">VOLTAGEM</label>
                        <input id="voltage" disabled type="text" :value="status.onu.voltage.value + ' ' + status.onu.voltage.unit" class="form-control" >
                    </div>
                </div>

                <slot></slot>

            </div>
        </div>
        <div class="panel-body" v-else>
            <h3 style="padding-left: 20px">
                <i class="fa fa-info-circle" aria-hidden="true"></i> BUSCANDO INFORMAÇÕES DA PACPON
            </h3>
        </div>
    </div>
</template>

<script>
import { Fiberhome } from "../../class/fiberhome";

export default {
    name: "StatusDaONU",
    props: {
        _id: {
            default: null
        }
    },
    data() {
        return {
            status: null,
            interval: null,
            buscando: false
        };
    },
    beforeMount() {
        this.buscar();
        this.interval = setInterval(() => this.buscar(), 60000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        async buscar() {
            this.buscando = true;
            let res = await Fiberhome.info(this._id);
            this.status = res.payload;
            this.buscando = false;
        }
    }
};
</script>

<style scoped>
</style>
